var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.11523 20.9472C8.27148 20.9472 8.52539 20.8886 8.76953 20.7519C14.3262 17.6367 16.2305 16.3183 16.2305 12.7539V5.28321C16.2305 4.25781 15.791 3.93555 14.9609 3.58399C13.8086 3.10547 10.0879 1.76758 8.93555 1.36719C8.67188 1.2793 8.38867 1.2207 8.11523 1.2207C7.8418 1.2207 7.55859 1.29883 7.30469 1.36719C6.15234 1.69922 2.42188 3.11524 1.26953 3.58399C0.449219 3.92579 0 4.25781 0 5.28321V12.7539C0 16.3183 1.91406 17.6269 7.46094 20.7519C7.71484 20.8886 7.95898 20.9472 8.11523 20.9472ZM8.11523 19.1797C7.95898 19.1797 7.80273 19.1211 7.50977 18.9453C2.99805 16.2109 1.55273 15.4101 1.55273 12.3926V5.58594C1.55273 5.25391 1.61133 5.12696 1.88477 5.01954C3.36914 4.4336 6.25 3.4668 7.72461 2.88086C7.88086 2.81251 8.00781 2.79297 8.11523 2.79297C8.22266 2.79297 8.34961 2.82227 8.50586 2.88086C9.98047 3.4668 12.8418 4.50196 14.3555 5.01954C14.6191 5.11719 14.6777 5.25391 14.6777 5.58594V12.3926C14.6777 15.4101 13.2324 16.2011 8.7207 18.9453C8.4375 19.1211 8.27148 19.1797 8.11523 19.1797Z",
    fill: "#3A78F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06055 15.2441C7.38281 15.2441 7.65625 15.0879 7.8418 14.7949L12.3145 7.76367C12.4219 7.57812 12.5488 7.36328 12.5488 7.13867C12.5488 6.70898 12.1582 6.42578 11.748 6.42578C11.4941 6.42578 11.25 6.57226 11.0742 6.86523L7.02148 13.3691L5.08789 10.8789C4.86328 10.5664 4.63867 10.4785 4.375 10.4785C3.94531 10.4785 3.62305 10.8203 3.62305 11.2597C3.62305 11.4648 3.71094 11.6797 3.84766 11.8652L6.2207 14.7949C6.47461 15.1172 6.72852 15.2441 7.06055 15.2441Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5918,
    height: 20.2441,
    fill: "white",
    transform: "translate(0 0.703125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/ShieldCheck.1b8e2ba78204371f650e019b7a55b53d.svg";
export { ForwardRef as ReactComponent };